<template>
	<div id="usuario-geral" class="relative">
		<upload-foto
			:foto.sync="fotoObj"
			:default.sync="fotoThumbObj"
			class="mb-4"
			:disabled.sync="disabled"
		/>
		<div class="flex flex-col relative">
			<div class="dados-usuario">
				<h4 class="subtitle mt-10 mb-4 font-bold">Dados do usuário</h4>

				<vs-input
					name="cpf"
					class="w-full mb-4"
					label="CPF"
					v-mask="'###.###.###-##'"
					v-model="cpfObj"
					:disabled="cpfDisabled || disabled"
					@input="() => removeError('cpf')"
				></vs-input>

				<vs-input
					name="nome"
					class="w-full mb-4"
					label="Nome"
					v-model="nomeObj"
					:disabled="disabled"
					@input="() => removeError('nome')"
				></vs-input>

				<vs-input
					name="email"
					class="w-full mb-4"
					label="E-mail"
					v-model="emailObj"
					:disabled="disabled"
					@input="() => removeError('email')"
				></vs-input>

				<vs-input
					class="w-full mb-4"
					label="Telefone (Opcional)"
					name="telefone"
					v-mask="['(##) # ####-####', '(##) ####-####']"
					v-model="telefoneObj"
					:disabled="disabled"
				></vs-input>

				<vs-input
					name="data_nascimento"
					class="w-full"
					label="Data de nascimento (Opcional)"
					v-model="dataNascimentoObj"
					:disabled="disabled"
					@input.native="handlerFormatInputData"
				></vs-input>
			</div>

			<div class="endereco">
				<h4 class="subtitle mt-10 mb-4 font-bold">Endereço</h4>

				<vs-input
					class="w-full mb-4"
					label="CEP (Opcional)"
					name="cep"
					v-mask="'#####-###'"
					v-model="cepObj"
					:disabled="disabled"
					@input="consultarCEP"
				></vs-input>

				<vs-input
					class="w-full mb-4"
					label="Rua (Opcional)"
					name="logradouro"
					v-model="logradouroObj"
					:disabled="disabled"
				></vs-input>

				<vs-input
					class="md:w-2/5 w-full mb-4"
					label="Número (Opcional)"
					name="numero"
					type="number"
					v-model="numeroObj"
					:disabled="disabled"
				></vs-input>

				<vs-input
					class="w-full mb-4"
					label="Complemento (Opcional)"
					name="complemento"
					v-model="complementoObj"
					:disabled="disabled"
				></vs-input>

				<vs-input
					class="w-full mb-4"
					label="Bairro (Opcional)"
					name="bairro"
					v-model="bairroObj"
					:disabled="disabled"
				></vs-input>

				<vs-input
					class="w-full mb-4"
					label="Cidade (Opcional)"
					name="cidade"
					v-model="cidadeObj"
					:disabled="disabled"
				></vs-input>

				<ld-select
					parent="#usuario-geral"
					label="Estado (Opcional)"
					name="estado"
					:model.sync="estadoObj"
					:list.sync="listEstados"
					:disabled="disabled"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import Estado from "../../../../models/Estado";
import UploadFoto from "../upload_foto/UploadFoto";
import CEPHelper from "../../../../helpers/CEPHelper";
import DateHelper from "../../../../helpers/DateHelper";

export default {
	name: "Geral",
	components: {
		UploadFoto
	},
	props: {
		usuario: {
			required: true
		},
		foto: {
			required: true
		},
		fotoThumb: {
			required: false
		},
		nome: {
			required: true
		},
		cpf: {
			required: true
		},
		email: {
			required: true
		},
		telefone: {
			required: true
		},
		dataNascimento: {
			required: true
		},
		cep: {
			required: true
		},
		logradouro: {
			required: true
		},
		numero: {
			required: true
		},
		complemento: {
			required: true
		},
		bairro: {
			required: true
		},
		cidade: {
			required: true
		},
		estado: {
			required: true
		},
		cpfDisabled: {
			type: Boolean,
			default: false
		},
		removeError: {
			type: Function,
			required: true
		},
		edicao: {
			default: false,
			type: Boolean
		},
	},
	computed: {
		disabled() {
			return ((!this.$permissions.can('colaboradormodificar') && this.edicao) || (!this.$permissions.can('colaboradoradicionar') && !this.edicao)) && !this.$permissions.can('autenticadosuperuser');
		},
		listEstados() {
			const estados = Estado.getMap();

			const listEstados = [
				{},
				...Object.keys(estados).map(estado => {
					return {
						text: estado,
						value: estados[estado]
					};
				})
			];

			return listEstados;
		},
		fotoObj: {
			set(value) {
				this.$emit("update:foto", value);
			},
			get() {
				return this.foto;
			}
		},
		fotoThumbObj: {
			set(value) {
				this.$emit("update:fotoThumb", value);
			},
			get() {
				return this.fotoThumb;
			}
		},
		nomeObj: {
			set(value) {
				this.$emit("update:nome", value);
			},
			get() {
				return this.nome;
			}
		},
		cpfObj: {
			set(value) {
				this.$emit("update:cpf", value);
			},
			get() {
				return this.cpf;
			}
		},
		emailObj: {
			set(value) {
				this.$emit("update:email", value);
			},
			get() {
				return this.email;
			}
		},
		telefoneObj: {
			set(value) {
				this.$emit("update:telefone", value);
			},
			get() {
				return this.telefone;
			}
		},
		dataNascimentoObj: {
			set(value) {
				this.$emit("update:dataNascimento", value);
			},
			get() {
				return this.dataNascimento;
			}
		},
		cepObj: {
			set(value) {
				this.$emit("update:cep", value);
			},
			get() {
				return this.cep;
			}
		},
		logradouroObj: {
			set(value) {
				this.$emit("update:logradouro", value);
			},
			get() {
				return this.logradouro;
			}
		},
		numeroObj: {
			set(value) {
				this.$emit("update:numero", value);
			},
			get() {
				return this.numero;
			}
		},
		complementoObj: {
			set(value) {
				this.$emit("update:complemento", value);
			},
			get() {
				return this.complemento;
			}
		},
		bairroObj: {
			set(value) {
				this.$emit("update:bairro", value);
			},
			get() {
				return this.bairro;
			}
		},
		cidadeObj: {
			set(value) {
				this.$emit("update:cidade", value);
			},
			get() {
				return this.cidade;
			}
		},
		estadoObj: {
			set(value) {
				this.$emit("update:estado", value);
			},
			get() {
				return this.estado;
			}
		}
	},
	methods: {
		async consultarCEP(cep) {
			try {
				await CEPHelper.consultarCEP.get(cep, this.usuario);
			} catch (error) {
				console.error(error);
			}
		},
		handlerFormatInputData(event) {
			DateHelper.dateMask(event);
		}
	}
};
</script>

<style lang="scss" src="./geral.scss"></style>
